"use client";

import type { ReactNode } from "react";

import { cn } from "../../utils";

export type LayoutContentProps = {
  className?: string;
  children: ReactNode;
};

const Content = ({ className, children }: LayoutContentProps) => {
  return (
    <>
      <style>
        {`*:focus-visible {
          outline: none;
        }`}
      </style>
      <div className={cn("layout-content relative flex size-full flex-1 flex-col overflow-hidden", className)}>
        {children}
      </div>
    </>
  );
};

export default Content;
